import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceRemoveAllocationNotificationState = createStateReducer(
  initialState,
  {
    [events.removeAllocationSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeAllocation",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.removeAllocationFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeAllocation",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceRemoveAllocationNotificationState };
